<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>


    <!--  hero banner   -->
    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="https://static1.squarespace.com/static/5640e06be4b06f94eb099930/58af5e8fbf629a82a110ca5c/58b1fdec9de4bb80d4748fd2/1488215663273/Digital+communication+Systems.jpg?format=1500w">
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">Aeroviewer for Creative offices – Digital communication companies</h1>
            </div>
        </div>
    </section>
    <!--  End of hero banner   -->


    <!-- Section Title -->
    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 block-title m-b-0">AEROVIEWER is one of the best sources for creative aerial
                        content</p>
                    <p class="h2 m-t-5 light">
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- End section title -->


    <section class="bg-master-lightest p-b-15 p-t-15">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <div class="row">
                    <div class="col">
                        <h5 class="block-title hint-text no-margin">Boost Conversions and Sales with videos and
                            photos</h5>
                        <p class="h4 m-t-5">Without doubt, video marketing is one of the hottest additions to promotion
                            toolbox.
                        </p>
                        <p class="h4 hint-text font-arial no-padding">
                            There are many show cases proving that by adding a product video on your landing page can
                            increase conversions even by 80%. <br> Latest studies show that the majority of
                            users who watched an explainer-video about a product
                            subsequently bought it.
                        </p>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <img class="image-responsive-height" src="/static/web/assets/images/digital-1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="bg-master-lightest p-b-15 p-t-15">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">

                <div class="row">
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <img class="image-responsive-height" src="/static/web/assets/images/digital-3.png" alt="">
                    </div>
                    <div class="col">
                        <h5 class="block-title hint-text no-margin">Visual content doesn' t come easy</h5>
                        <p class="h4 m-t-5">Although visual content has a clear advantage for digital marketing, it's
                            usually <strong> neither easy nor affordable </strong> for
                            everyone.
                        </p>
                        <p class="h4 hint-text font-arial no-padding">
                            In fact in can be overwhelming. You have to search tons of stock
                            footage or photos to find just a couple of photos or some interesting video seconds.
                            <br>
                            The average pricing is usually very high.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </section>


    <section class="p-b-50 p-t-50 bg-master-darkest" data-pages-bg-image="/static/web/assets/images/about_us.jpg"
             data-bg-overlay="#333"
             data-overlay-opacity="0.4">
        <div class="container p-b-50 p-t-50">
            <div class="row">
                <div class="col">
                    <div class="text-center">
                        <p class="h2 text-white p-b-10"> We offer unique professional quality and uniformity to all
                            creative
                            professionals along with our
                            completely different concept when it comes to video footage selection.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-overlay" style="background-color: black; opacity: 1;"></div>
    </section>


    <!-- Contributors section#1 -->
    <section class="bg-master-lightest p-b-15 p-t-15">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <div class="row">
                    <div class="col">
                        <h5 class="block-title hint-text no-margin">Boost your digital marketing with AEROVIEWER</h5>
                        <p class="h4 m-t-5">You can simply <strong>record</strong> your preferred duration from our
                            videos
                            and just get what you need, not more or less.
                        </p>
                        <p class="h4 hint-text font-arial no-padding">
                            Explore our 300 hours continues video and 800000 synced photos with our innovative tools
                            and build your digital marketing in no time.
                        </p>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <img class="image-responsive-height" src="/static/web/assets/images/digital-4.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="bg-master-lightest p-b-15 p-t-15">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">

                <div class="row">
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <img class="image-responsive-height" src="/static/web/assets/images/digital-5.png" alt="">
                    </div>
                    <div class="col">
                        <h5 class="block-title hint-text no-margin">A complete and easy solution for everyone</h5>
                        <p class="h4 m-t-5">Use our <strong>DigiShare™ Service</strong> subscription to embed your
                            content directly in your websites or mobile app with only a few clicks.
                        </p>
                        <p class="h4 hint-text font-arial no-padding">
                            Within our platform you can use your photos and videos to create unique widgets that will be
                            streamed
                            by our infrastructure. Focus only in what matters to your business and let us
                            deliver your inspiration and provide you insight statistics.
                        </p>
                    </div>

                </div>

            </div>
        </div>
    </section>

    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 block-title m-b-0">Samples of the creative work implemented by <a
                            href="http://imagepro.team">ImagePro team </a> for the Greek National Tourism Organization,
                        using AEROVIEWER content. </p>
                </div>
            </div>
            <br>
            <br>

            <div class="row">
                <div class="col-4">
                    <style>.embed-container {
                        position: relative;
                        padding-bottom: 56.25%;
                        height: 0;
                        overflow: hidden;
                        max-width: 100%;
                    }

                    .embed-container iframe, .embed-container object, .embed-container embed {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }</style>
                    <div class='embed-container'>
                        <iframe src='https://www.youtube.com/embed/ba72QbpUxUE' frameborder='0'
                                allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-4">
                    <style>.embed-container {
                        position: relative;
                        padding-bottom: 56.25%;
                        height: 0;
                        overflow: hidden;
                        max-width: 100%;
                    }

                    .embed-container iframe, .embed-container object, .embed-container embed {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }</style>
                    <div class='embed-container'>
                        <iframe src='https://www.youtube.com/embed/N4mUX43gD-I' frameborder='0'
                                allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-4">
                    <style>.embed-container {
                        position: relative;
                        padding-bottom: 56.25%;
                        height: 0;
                        overflow: hidden;
                        max-width: 100%;
                    }

                    .embed-container iframe, .embed-container object, .embed-container embed {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                    }</style>
                    <div class='embed-container'>
                        <iframe src='https://www.youtube.com/embed/DFkuvYeMCEY' frameborder='0'
                                allowfullscreen></iframe>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <avr-footer></avr-footer>

    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/creative/app.tag.html